// extracted by mini-css-extract-plugin
export default {"tx":"eea10a91fa","line":"f0f51ac6d2"};